var DurationDisplayFormat;
(function (DurationDisplayFormat) {
  DurationDisplayFormat["HoursAndMinutes"] = "HHH:MM";
  DurationDisplayFormat["DaysAndHoursAndMinutes"] = "DD:HH:MM";
})(DurationDisplayFormat || (DurationDisplayFormat = {}));

export { DurationDisplayFormat };
